import { confirm } from 'devextreme/ui/dialog';
import { iBisViewComponent } from '@dohu/ibis-common';
import { Component } from '@angular/core';
import { ProxyService } from '../../../service/proxy.service';

@Component({
	templateUrl: 'user.component.html'
})
export class UserComponent extends iBisViewComponent {

	public customButtons; 
	constructor(public proxy: ProxyService) {
		super(proxy.user, proxy.lg, proxy.iui, proxy.activatedRoute);
		this.id = 'u_id';
		this.key = '[MDS]Users';

		this.generateCustomButtons();
	}

	

	checkIfActiv = (cell: any): boolean => {
		//return !cell.row.data.u_isActiv
		return false;
	}

	
	generateCustomButtons(): void {
		this.customButtons = [
			{hint: this.L('EDIT'), icon:'edit', onClick: this.onEditClick, visible: true, disabled: this.checkIfActiv },
		
		];
	}
}
